
    import { css } from 'lit-element';
    export default css`:host[disabled]{--kat-dropdown-hover-ring-color:transparent;--kat-dropdown-hover-ring-outlay:0}`;
  